import { render, staticRenderFns } from "./ConfigProdutoCaracteristicasList.vue?vue&type=template&id=b36b1b38"
import script from "./ConfigProdutoCaracteristicasList.vue?vue&type=script&lang=js"
export * from "./ConfigProdutoCaracteristicasList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports